import React, { useCallback, useRef, useEffect } from 'react';
import theme from './HeaderNotificationsButton.module.scss';
import { NotificationsSession } from '@/server-events/NotificationsSession';
import { useSelector } from 'react-redux';
import HeaderNotificationsIcon from './HeaderNotificationsIcon';
import NavigationContextMenu from '@/components/layout/NavigationContextMenu/NavigationContextMenu';
import { IState } from '@/state/IState';
import HeaderNotificationMenu from './HeaderNotificationsMenu';
import { INotification } from '@/types';

interface HeaderNotificationsButtonProps {
    open: boolean;
    toggle(flag: boolean): void;
}

const HeaderNotificationsButton: React.FC<HeaderNotificationsButtonProps> = ({ open, toggle }) => {
    const { notifications, totalCount } = useSelector((state: IState) => state.notifications);
    const numberOfNotifications = notifications.filter((x) => !x.viewDate).length;
    const notificationSession = useRef<NotificationsSession | null>(null);

    useEffect(() => {
        const newSession = new NotificationsSession();
        notificationSession.current = newSession;

        return function cleanup() {
            newSession.dispose();
        };
    }, []);

    const handleNotificationClick = useCallback((notification: INotification) => {
        notificationSession.current!.markAsClicked(notification);
    }, []);

    const handleRequestMore = useCallback(() => {
        notificationSession.current!.requestNotifications(notifications.length);
    }, [notifications.length]);

    useEffect(() => {
        if (open && notificationSession.current && notifications.some((x) => !x.viewDate)) {
            notificationSession.current.markAsViewed(notifications);
        }
    }, [open, notifications]);

    return (
        <NavigationContextMenu
            element={<HeaderNotificationsIcon sizeInPx={36} active={open} unreadNotificationCount={numberOfNotifications} />}
            open={open}
            className={theme.notificationsMenuContainer}
            menuClassName={theme.notificationsMenu}
            size="large"
            toggle={toggle}>
            <HeaderNotificationMenu
                requestMoreNotifications={totalCount !== notifications.length ? handleRequestMore : undefined}
                notifications={notifications}
                onNotificationClick={handleNotificationClick}
            />
        </NavigationContextMenu>
    );
};

export default HeaderNotificationsButton;
